import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Import the components for Patient and Doctor views and edits

import { useDispatch, useSelector } from "react-redux";
import { internalRoles } from "../../core/constants/rolePresets";
import { formConfigMap } from "../../core/constants/FieldConfigMap";
import FormFormat from "../../core/components/FormFormat";
import apiService from "../../core/services/apiService";
import UserDashboardPage from "./FormDetails/Index";
import { normalizeTableName } from "../../core/utils/tableUtils";
import useSocket from "../../core/hooks/useSocket";
import InventoryDetailsPage from "./FormDetails/InventoryForm/InventoryDetailsPage";

function Form() {
  const { tablename: rawTablename, view, id } = useParams();
  const dispatch = useDispatch();

  const [data, setData] = useState(null);

  const userInfo = useSelector((state) => state.user.userInfo);
  const hasValidRole = userInfo && internalRoles.includes(userInfo.type);

  const tablename = normalizeTableName(rawTablename);
  const [manualRefresh, setManualRefresh] = useState(0);

  useSocket({
    // When an existing user is updated
    user_updated: (data) => {
      setManualRefresh((prev) => prev + 1);
    },
  });

  useEffect(() => {
    if (view !== "create") {
      const fetchDetails = async () => {
        try {
          const record = await apiService.get(dispatch, `${tablename}/${id}`);

          setData(record);
        } catch (error) {
          console.error(`Error fetching ${tablename} details:`, error);
        }
      };

      fetchDetails();
    }
  }, [view, id, tablename, dispatch, manualRefresh]);

  if (!hasValidRole) return <div>Access denied</div>;
  // if (loading) return <div className="p-4">Loading...</div>;
  // if (view !== "create" && !data)
  //   return <div className="p-4">Record not found.</div>;

  const config = formConfigMap[tablename];
  if (!config) return <div>Invalid route or parameters.</div>;

  const fields = config.getFields(view);

  // ✅ Conditional component rendering
  if (
    view === "view" &&
    (tablename === "patients" ||
      tablename === "doctors" ||
      tablename === "users")
  ) {
    return <UserDashboardPage userData={data} />;
  }

  if (view === "view" && tablename === "inventory") {
    return <InventoryDetailsPage />;
  }

  return data && <FormFormat fields={fields} data={data} />;
}

export default Form;
